import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { GlassesIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const incognitoTamperingDefinition: SmartSignalDefinition<{ incognito?: IdEventV4['incognito'] }> = {
  key: 'incognito',
  label: 'Incognito mode',
  extract: (e) => ({ incognito: e.incognito }),
  icon(e) {
    const p = this.extract(e)?.incognito
    return (
      <GlassesIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.incognito
    return p ?? false
  },
  isWeb: () => true,
  isMobile: () => false,
  searchFor: '"incognito":',
  documentationHash: '#browser-incognito-detection',
  urlParamKey: IdentificationUrlKeys.Incognito,
}
